import React, { Component, Fragment } from 'react'
import moment from 'moment'

import AdminPanel from '../AdminPanel/AdminPanel'
import MenuPanel from '../MenuPanel/MenuPanel'
import Settings from 'settings'
import AuthService from '../../utils/AuthService'

import ReactGA from 'react-ga'
import { getLanguage } from '../../utils/Locale'
import { getUrlParam, getUrlVars } from '../../utils/UrlUtils'

class Main extends Component {
    authService = new AuthService()

    state = {
        displayMode: null,
        date: null,
        dayCount: null,
        concept: null,
        entityId: null,
        siteId: null,
        service: null,
        language: 'fr',
        menu: '',
        kiosks: [],

        file: null,

        isAdmin: false,
        isAuthenticated: false,
    }
    componentWillMount() {
        const parametersCount = Object.keys(getUrlVars()).length

        if (getUrlVars().utm_source) {
            this.setState({ isAuthenticated: true, useDefaultValues: true })
        }
        if (parametersCount === 0) {
            this.setState({ isAuthenticated: true })
            return
        }

        let dataSource = getUrlParam('dataSource', '')
        if (dataSource === 'winrest') {
            if (!getUrlParam('siteSlug')) {
                dataSource = 'winrest2'
            }
        }

        const displayMode = getUrlParam('mode', 'week')

        let date = getUrlParam('date', moment().format('YYYY-MM-DD'))
        if (date === 'today') {
            date = moment().format('YYYY-MM-DD')
        }
        const dayCount = getUrlParam('dayCount', 5)
        const startDay = getUrlParam('startDay', null)

        const concept = getUrlParam('mkt', 'lppdc')
        const entityId = getUrlParam('entityId', null)
        const siteId = getUrlParam('siteId', null)
        const file = getUrlParam('f', null)
        let title = getUrlParam('t', null)
        if (title) {
            title = decodeURIComponent(title)
        }
        let subtitle = getUrlParam('st', null)
        if (subtitle) {
            subtitle = decodeURIComponent(subtitle)
        }

        const service = getUrlParam('s', null)
        const language = getUrlParam('l', null)
        const menu = getUrlParam('menu', '')

        const print = getUrlParam('print', null)
        const showDate = JSON.parse(getUrlParam('showDate') || false)

        const includedKiosks = getUrlParam('kiosks', 'all')

        const zoom = getUrlParam('zoom', 1)
        const orientation = getUrlParam('orientation', 'landscape')
        const size = getUrlParam('size', 'A4')

        // winrest Params
        const recipes = getUrlParam('recipes', '')
        const winrestURL = getUrlParam('url', '')
        const pointOfSale = getUrlParam('pointOfSaleSlug', '')
        const mealTypeSlug = getUrlParam('mealTypeSlug', '')
        const menuSlug = getUrlParam('menuSlug', '')
        const siteSlug = getUrlParam('siteSlug', '')
        const guestTypeSlug = getUrlParam('guestTypeSlug', '')
        const hideMenuPrice = JSON.parse(getUrlParam('hideMenuPrice') || 'true')
        const hideRecipePoints = JSON.parse(
            getUrlParam('hideRecipePoints') || 'true'
        )
        const hideEnergyKcal = JSON.parse(
            getUrlParam('hideEnergyKcal') || 'false'
        )
        const showEnergyKcalByPortion = JSON.parse(
            getUrlParam('showEnergyKcalByPortion') || 'false'
        )
        const hideComposition = JSON.parse(
            getUrlParam('hideComposition') || 'false'
        )
        const hideLabels = JSON.parse(getUrlParam('hideLabels') || 'false')
        const hideIntolerences = JSON.parse(getUrlParam('hideIntolerences') || 'false')
        const isDuoKiosk = JSON.parse(getUrlParam('isDuoKiosk') || 'false')
        const useCommercialName =
            getUrlParam('useCommercialName') === 'true' ? true : false

        const columns = getUrlParam('columns', null)

        const excludedDays = getUrlParam('excludedDays', '')
            .split(',')
            .map(_ => parseInt(_))

        /** New WINREST initialization query params */
        const pointOfSaleId = getUrlParam('pointOfSaleId', '')
        const guestTypeId = getUrlParam('guestTypeId', '')
        const mealTypeId = getUrlParam('mealTypeId', '')
        const menuId = getUrlParam('menuId', '')
        const recipeTypeIds = getUrlParam('recipeTypeIds', '')
        const pictures = getUrlParam('pictures', '')
        const currency = getUrlParam('currency', '')

        this.setState({
            recipes: recipes.split(','),
            winrestURL,
            pointOfSale,
            mealTypeSlug,
            hideMenuPrice,
            hideRecipePoints,
            hideEnergyKcal,
            showEnergyKcalByPortion,
            hideComposition,
            hideLabels,
            hideIntolerences,
            isDuoKiosk,
            menuSlug,
            siteSlug,
            useCommercialName,
            guestTypeSlug,
            dataSource: dataSource || 'excel',
            displayMode,
            date,
            dayCount: parseInt(dayCount),
            startDay,

            concept,
            entityId,
            siteId,
            file,
            title,
            subtitle,
            service,
            language,
            menu,

            zoom,
            orientation,
            size,
            print,
            showDate,
            kiosks: includedKiosks.split(','),
            columns,
            excludedDays,

            pointOfSaleId,
            guestTypeId,
            mealTypeId,
            menuId,
            recipeTypeIds,
            pictures,
            currency
        })

        const gaEntity = dataSource === 'winrest' ? winrestURL : entityId
        const gaSite = dataSource === 'winrest' ? siteSlug : siteId
        const gaPointOfSale = dataSource === 'winrest' ? pointOfSale : siteId

        ReactGA.initialize('UA-151593081-1', {
            debug: false,
            siteSpeedSampleRate: 100,
        })
        ReactGA.set({ dimension1: dataSource })
        ReactGA.set({ dimension2: gaEntity })
        ReactGA.set({ dimension3: gaSite })
        ReactGA.set({ dimension4: gaPointOfSale })
        ReactGA.set({ dimension5: displayMode })
        ReactGA.pageview(window.location.pathname + window.location.search)
    }

    render() {
        return (
            <Fragment>
                {this.state.isAuthenticated ? (
                    <AdminPanel
                        defaultValues={
                            this.state.useDefaultValues
                                ? { ...this.state }
                                : undefined
                        }
                    />
                ) : (
                    <MenuPanel {...this.state} />
                )}
            </Fragment>
        )
    }
}

export default Main
